import styled from 'styled-components';
import WidestInventorySvg from '../../../assets/onboardingNew/homepage/widest-inventory.svg';

const WidestInventoryNewIcon = styled(WidestInventorySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.6rem'};
height: ${props => props.height || '3.6rem'};
display: flex;
`;

export default WidestInventoryNewIcon;
